import getFunctionData from "../../../../utils/get-function-data";
import optimizeSingleAttribute from "../../../../utils/process-dataset/optimize-single-attribute";

/**
 * Optimize computed (function with property) initial string
 * @param {String} parent
 * @param {String} values
 * @returns {Map<"name" | "parameters", string>}
 */
const optimizeInitialParent = (parent, values) => {
  const map = new Map();

  const optimized = optimizeSingleAttribute(`${parent}(${values})`);
  const data = getFunctionData(optimized);
  const name = data.get("name");
  const parameters = data.get("parameters");

  map.set("name", name);
  map.set("parameters", parameters);

  return map;
};

export default optimizeInitialParent;
